<template>
  <svg
      data-name="レイヤー 1"
      id="レイヤー_1"
      viewBox="0 0 6 6.93"
      xmlns="http://www.w3.org/2000/svg"
  >
    <g
        data-name="レイヤー 2"
        id="レイヤー_2"
    >
      <g id="text">
        <polygon
            points="6 3.46 0 0 0 6.93 6 3.46"
            style="fill:var(--v-secondary-base)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ListIcon",
  data() {
    return {
      accentColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
  },
}
</script>

<style>

</style>